import { Fragment } from "react";
import Footer from "../../component/layout/footer";
import Header from "../../component/layout/header";
import PageHeaderTwo from "../../component/layout/pageheader-2";
import Author from "../../component/sidebar/author";
import Comment from "../../component/sidebar/comment";
import CourseSideCetagory from "../../component/sidebar/course-cetagory";
import CourseSideDetail from "../../component/sidebar/course-detail";
import Respond from "../../component/sidebar/respond";
import Stage from "../../component/layout/Sing/stage";


const StagePerformanceSingle = () => {

    // -------- Tutors for Stage Performance Category --------
    const stageTutors = [
        {
            name: "John Mathews",
            expertise: "Live Stage Performance & Mic Handling",
            experience: "12 Years Experience",
        },
        {
            name: "Emily Roberts",
            expertise: "Performance Coaching & Confidence Building",
            experience: "10 Years Experience",
        },
        {
            name: "Michael Lee",
            expertise: "Stage Presence & Vocal Projection",
            experience: "8 Years Experience",
        },
    ];

    return (
        <Fragment>
            <Header />
            <Stage title="Stage Performance & Mic Handling" />

            <div className="course-single-section padding-tb section-bg" style={{ backgroundColor: "#E0F7FA" }}>
                <div className="container">
                    <div className="row justify-content-center">

                        {/* LEFT CONTENT */}
                        <div className="col-lg-8">
                            <div className="main-part">

                                {/* Course Overview */}
                                <div className="course-item">
                                    <h3>Stage Performance Overview</h3>
                                    <p>Learn confidence, stage presence, mic handling, and live singing skills.</p>
                                </div>

                                {/* ---------- Course Video Section ---------- */}
                                <div className="course-video" style={{ marginTop: "40px" }}>
                                    <div className="course-video-title">
                                        <h4>Course Content</h4>
                                    </div>

                                    <div className="course-video-content">
                                        <div className="accordion" id="StagePerfAcc">
                                            <div className="accordion-item">
                                                <div className="accordion-header" id="sp01">
                                                    <button className="d-flex justify-content-between" data-bs-toggle="collapse" data-bs-target="#videolist1" aria-expanded="true" aria-controls="videolist1">
                                                        <span>1. Stage Presence & Mic Basics</span>
                                                        <span>5 Lessons</span>
                                                    </button>
                                                </div>

                                                <div id="videolist1" className="accordion-collapse collapse show" aria-labelledby="sp01" data-bs-parent="#StagePerfAcc">
                                                    <ul className="lab-ul video-item-list">
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.1 Welcome & Course Introduction – 03:00 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.2 Stage Presence Basics – 04:30 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.3 Mic Handling Techniques – 05:20 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.4 Voice Projection & Modulation – 06:10 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.5 Stage Confidence Practice – 07:00 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* ---------- End Course Video Section ---------- */}

                                {/* ---------- Tutors Section ---------- */}
                                <div style={{ marginTop: "40px", padding: "20px", background: "#FFFFFF", borderRadius: "10px" }}>
                                    <h3 style={{ marginBottom: "20px" }}>Stage Performance Tutors</h3>

                                    {stageTutors.map((tutor, index) => (
                                        <div key={index} style={{ padding: "15px", borderBottom: "1px solid #ddd" }}>
                                            <h5 style={{ margin: 0 }}>{tutor.name}</h5>
                                            <p style={{ margin: "5px 0" }}>{tutor.expertise}</p>
                                            <small style={{ color: "#666" }}>{tutor.experience}</small>
                                        </div>
                                    ))}
                                </div>
                                {/* ---------- End Tutors Section ---------- */}

                                {/* Default Components */}
                                <Author />
                                <Comment />
                                <Respond />
                            </div>
                        </div>

                        {/* RIGHT SIDEBAR */}
                        <div className="col-lg-4">
                            <div className="sidebar-part">
                                <CourseSideDetail />
                                <CourseSideCetagory />
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </Fragment>
    );
};

export default StagePerformanceSingle;
